import { Container, SxProps, Theme } from "@mui/material";
import React from "react";
import useViewportWidth from "../../hooks/useViewportWidth";

interface ContainerBlockProps {
	children: React.ReactNode;
	sx?: SxProps<Theme>;
	ref?: any;
}

const ContainerBlock: React.FC<ContainerBlockProps> = ({
	children,
	sx,
	ref,
}) => {
	const viewportWidth = useViewportWidth();
	const isBelowXl = viewportWidth < 1920;

	return (
		<Container
			ref={ref}
			disableGutters
			maxWidth={isBelowXl ? "lg" : "xl"}
			sx={{ px: { xs: "20px", sm: 2, md: 4, lg: 4 }, ...sx }}
		>
			{children}
		</Container>
	);
};

export default ContainerBlock;
